<script>
    import {JSONClone} from '../lib/lib';
    import app_alert from "../stores/alerts";
    import success from "../stores/success";

    export let label = null;
    export let mobiles = null;

    let strMobiles = '';

    const initialize = () => {
        if (mobiles.constructor === String) {
            strMobiles = JSONClone(mobiles);
            strMobiles = strMobiles.replaceAll("<br>", "\n");
        } else {
            strMobiles = mobiles.join("\n");
        }
    }

    const copy = async () => {
        let el = document.getElementById('mobiles')
        el.select();
        try {
            document.execCommand('copy');
            success.show("Τα τηλέφωνα αντιγράφτηκαν στο πρόχειρο.");
        } catch (err) {
            app_alert.show('error', 'Η αντιγραφή στο πρόχειρο δεν υποστηρίζεται από τον browser σας.');
        }
    }

    $:{
        if (mobiles && mobiles.length && strMobiles === '') {
            initialize();
        }
    }
</script>
<div class="form-group">
    {#if label}
        <label>{ label }</label>
    {/if}
    <div class="mobiles-container">
        <textarea class="form-control" id="mobiles" style="max-width: 100%" rows="10" value="{ strMobiles }"></textarea>
        <button class="btn btn-default btn-sm copy-button" title="αντιγραφή στο πρόχειρο" on:click={ copy }><i class="fa fa-files-o"></i>
        </button>
    </div>
</div>

<style>
    .mobiles-container {
        position: relative;
    }
    .mobiles-container textarea {
        min-width: 100%;
        max-width: 100%;
        overflow-y: scroll;
    }

    .copy-button {
        position: absolute;
        top: 5px;
        right: 20px;
    }
</style>